import { useEffect } from 'react'
import './utils/i18n'
import Router from './Router'
import SelectedMotifsContext from './contexts/selectedMotifContext'
import MotifDetailsContext from './contexts/motifDetailsContext'
import PanelsContext from './contexts/panelsContext'
import AppStatusContext from './contexts/appStatusContext'
import SnackbarContext from './contexts/snackbarContext'
import OnboardingContext from './contexts/onboardingContext'
import { useEnv } from './utils/useEnv'
import MotifGeneratorContext from './contexts/motifGeneratorContext'
import StaticTextContext from './contexts/staticTextContext'
import { useTranslation } from 'react-i18next'
// import { useIdleTimer } from './utils/idleTimer'
// import routePaths from './constants/routePaths'

function App() {
  const { isLocalDev, isKiosk } = useEnv()
  const { i18n, t } = useTranslation()
  const userLang = navigator.language

  // TODO: Uncomment this when screensaver animation is unused
  // useIdleTimer({
  //   callback: () => window.location.replace(routePaths.HOME),
  // })

  if (!isLocalDev) {
    window.addEventListener(
      'contextmenu',
      function (event) {
        event.preventDefault()
      },
      false,
    )
  }

  useEffect(() => {
    if (isKiosk) {
      document.querySelector('body')?.classList.add('noselect')
    }

    i18n.changeLanguage(userLang.split('-')[0])
  }, [])

  useEffect(() => {
    document.title = t('appTitle')
  }, [i18n.language, t])

  return (
    // Add global contexts here
    <AppStatusContext>
      <SnackbarContext>
        <OnboardingContext>
          <PanelsContext>
            <StaticTextContext>
              <MotifDetailsContext>
                <SelectedMotifsContext>
                  <MotifGeneratorContext>
                    <Router />
                  </MotifGeneratorContext>
                </SelectedMotifsContext>
              </MotifDetailsContext>
            </StaticTextContext>
          </PanelsContext>
        </OnboardingContext>
      </SnackbarContext>
    </AppStatusContext>
  )
}

export default App
